// extracted by mini-css-extract-plugin
export default {"container":"MainPage_container__WFfJ0","article":"MainPage_article__Wizn5"};